// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 860 ? "menu" : chunkId) + "." + {"142":"dba22f3cbb3cdeda","151":"50bc3b40616e2760","239":"e18916e449e167c8","860":"5913b9b3e0172216"}[chunkId] + ".js";
};